import { useState } from "react";
import { ModalContext } from "./ModalContext";
import { connectWallet, connectWalletLocaly, isWalletConnected , disconnectWallet } from '../config';

const ContextProvider = ({ children }) => {
  const [visibility, setVisibility] = useState(false);
  const [walletModalvisibility, setModalvisibility] = useState(false);
  const [shareModalVisibility, setShareModalvisibility] = useState(false);
  const [errorModalVisibility, setErrorModalVisibility] = useState(false);
  const [metamaskModalVisibility, setMetamaskModalVisibility] = useState(false);
  const [connectWalletModal, setConnectWalletModal] = useState(false);
  const [account, setAccount] = useState('');
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")
  
  const loadingHandle = () => {
    setIsLoading(!isLoading)  
  }

  const errorModalHandle = (message) => {
    setErrorMessage(message)
    setErrorModalVisibility(!errorModalVisibility)
  }

  const mintModalHandle = () => {
    setVisibility(!visibility);
  };
  const walletModalHandle = () => {
    //console.log("walletModalvisibility = " + !walletModalvisibility)
    setModalvisibility(!walletModalvisibility);
  };
  const shareModalHandle = (e) => {
    e.preventDefault();
    setShareModalvisibility(!shareModalVisibility);
  };

  const metamaskModalHandle = () => {
    setMetamaskModalVisibility(!metamaskModalVisibility);
  };

  const connectWalletModalHanlde = () => {
    if(!isWalletConnected()){
      setConnectWalletModal(!connectWalletModal);
    }
  };

  const connectWalletHandle = async () => {
    const accounts = await connectWallet();
    //console.log("connectWalletHandle accounts: " + accounts)
    setAccount(accounts);
    if(!isWalletConnected()){
      connectWalletLocaly();
    }
    setModalvisibility(!walletModalvisibility);
  };

  const isWalletAlreadyConnected = async () => {
    //console.log("isWalletAlreadyConnected: " + isWalletConnected())
    if(isWalletConnected()){
      const accounts = await connectWallet();
      setAccount(accounts);
    }
  };

  const disconnectWalletFromApp = () => {
    disconnectWallet()
    setAccount('');
  };

  return (
    <ModalContext.Provider
      value={{
        visibility,
        mintModalHandle,
        walletModalHandle,
        walletModalvisibility,
        shareModalVisibility,
        shareModalHandle,
        metamaskModalVisibility,
        metamaskModalHandle,
        account,
        connectWalletHandle,
        isWalletAlreadyConnected,
        disconnectWalletFromApp,
        connectWalletModalHanlde,
        connectWalletModal,
        errorModalHandle,
        errorModalVisibility,
        loadingHandle,
        isLoading
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

export default ContextProvider;
